import { BaseApi } from 'api/base.api'

// Interface
import {
  IAboutUsMottoApi,
  IAboutUsMottoApiRequest,
  IAboutUsMottoApiGetAttrs,
  IAboutUsMottoApiGetResponse,
  IAboutUsMottoApiSaveAttrs,
  IAboutUsMottoApiSaveResponse,
} from 'interfaces/back-office/content-management/about-us/motto/about-us-motto-api.interface'

// Constant
import { ApiConstant } from 'constant'
import { ABOUT_US_MOTTO } from 'constant/content-management/about-us/about-us-motto.constant'

// Utils
import { commonUtils_delay } from 'utils/common/common.utils'

export class AboutUsMottoApi extends BaseApi<IAboutUsMottoApi> implements IAboutUsMottoApiRequest {
  readonly url = ApiConstant.CONTENT_ABOUT_US_MOTTO_URL

  /**
   * @description Get home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsMottoApiGetAttrs} payload
   *
   * @return {Promise<IAboutUsMottoApiGetResponse>} Promise<IAboutUsMottoApiGetResponse>
   */
  async aboutUsMotto_getAboutUsMotto(payload: IAboutUsMottoApiGetAttrs): Promise<IAboutUsMottoApiGetResponse> {
    try {
      // const response = await this.POST('/', payload.body, { ...payload.requestConfig })

      await commonUtils_delay(300)

      return Promise.resolve(ABOUT_US_MOTTO)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsMottoApiSaveAttrs} payload
   *
   * @return {Promise<IAboutUsMottoApiSaveResponse>} Promise<IAboutUsMottoApiSaveResponse>
   */
  async aboutUsMotto_saveAboutUsMotto(payload: IAboutUsMottoApiSaveAttrs): Promise<IAboutUsMottoApiSaveResponse> {
    try {
      // const requestPayload: IBaseApiRequestPayload = {
      //   method: payload.params?.id ? 'PUT' : 'POST',
      //   url: payload.params?.id ? `${this.url}/${payload.params.id}` : this.url,
      // }
      // const response = await this[requestPayload.method](requestPayload.url, {}, { ...payload.requestConfig })

      await commonUtils_delay(300)

      return Promise.resolve(ABOUT_US_MOTTO)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
